import {SmartComponent} from "smart-component-js";
import $ from "jquery";

class HighlightContainerComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "HighlightContainerComponent";
        super(element, parentComponent, params);

        this.$el = $(element);
        if(this.$el.find('#showAllHighlights').length > 0) {
            this.$el.find('#showAllHighlights').click(()=>{
                this.$el.find('#showAllHighlights').hide();
                this.$el.find('.high-el:hidden').show();
            });
        }
    }
}

export default HighlightContainerComponent;